/**
 * Ikonkalar — PDP DS: lucide-react, `strokeWidth: 1.85`, `currentColor`.
 * Emoji taqiqlanadi. `Icon`/`NavIcon` API si saqlangan — sahifalar shunga
 * tayanadi, faqat chizish endi lucide dan.
 *
 * `PulseMark` — brend belgisi (favicon varianti, 5 ustun): brandbook 32 px
 * dan pastda aynan shuni talab qiladi, u paketdan emas, o'z SVG imiz.
 */

import {
  Activity,
  AlertTriangle,
  BarChart3,
  CheckSquare,
  ChevronLeft,
  FileText,
  Loader2,
  Phone,
  Settings,
  Sparkles,
  UserRound,
  UserSearch,
  Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

import type { NavIcon } from "../app/nav";

/** DS talabi: strokeWidth 1.85 — hamma lucide ikonlar uchun yagona. */
const STROKE = 1.85;

/** Brend belgisi — 5 ustunli favicon varianti (BREND.md nisbatlari). */
export function PulseMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
      <circle cx="100" cy="100" r="100" fill="#2168F2" />
      <g fill="#FFFFFF">
        <rect x="26.5" y="76" width="23" height="48" rx="6" />
        <rect x="106.5" y="42" width="23" height="116" rx="6" />
        <rect x="146.5" y="64" width="23" height="72" rx="6" />
        <rect x="186.5" y="78" width="23" height="44" rx="6" />
      </g>
      {/* Urish ustuni — aksent sariq, eng oxirida chiziladi. */}
      <rect x="66.5" y="15" width="23" height="170" rx="6" fill="#FFC700" />
    </svg>
  );
}

/** Nav nomi → lucide ekvivalenti. */
const NAV_ICON: Record<NavIcon, LucideIcon> = {
  pulse: Activity,
  calls: Phone,
  analytics: BarChart3,
  alert: AlertTriangle,
  leads: UserSearch,
  assistant: Sparkles,
  team: Users,
  report: FileText,
  profile: UserRound,
  settings: Settings,
  tasks: CheckSquare,
  my: UserRound,
};

export function Icon({ name, className }: { name: NavIcon; className?: string }) {
  const LucideComponent = NAV_ICON[name];
  return <LucideComponent className={className} strokeWidth={STROKE} aria-hidden="true" />;
}

/** Chapga qaytish. */
export function BackIcon({ className }: { className?: string }) {
  return <ChevronLeft className={className} strokeWidth={STROKE} aria-hidden="true" />;
}

/** Yuklanish aylanasi. */
export function SpinnerIcon({ className }: { className?: string }) {
  return (
    <Loader2
      className={className}
      strokeWidth={STROKE}
      aria-hidden="true"
      style={{ animation: "spin 0.8s linear infinite" }}
    />
  );
}
